import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Common_main_banner_lottie from '../../../animations/common_main_banner_lottie/Common_main_banner_lottie';
import "./Common_main_banner.css";

function Common_main_banner({ animationData, slides }) {
    return (
        <section className="Common_main_banner">
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-md-8 col-8">
                        <Swiper
                            navigation={true} spaceBetween={10}
                            modules={[Navigation]}
                            className="banner_text_img_slider mySwiper_common_swiper"
                        >
                            {slides.map((slide, index) => (
                                <SwiperSlide key={index}>
                                    <div className="text_holder">
                                        <h3>{slide.heading}</h3>
                                        <p>{slide.subheading}</p>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    <div className="col-md-4 col-4">
                        <div className="img_bar_holder">
                            <div className="img_holder">
                                <Common_main_banner_lottie animationData={animationData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="t_and_c_text_holder">
                <p>*T&C Apply</p>
            </div>
        </section>
    );
}


export default Common_main_banner;
